export default "__VITE_ASSET__b7a1d654__"